import { produce } from 'immer'
import { State } from '../../typings'
import type { SetEditStatusForActivityAction } from './typings'

export const setEditStatusForActivityProducer = produce<
  State,
  [SetEditStatusForActivityAction['payload']]
>((draft, payload) => {
  draft.editStatusActivityId = payload
})
